export default __webpack_public_path__ + "static/media/blood-transfusion.597568fe.png";